<template>
<section class="tw-min-h-screen tw-w-full tw-flex tw-items-center tw-pt-10 tw-px-2">
    <div class="tw-max-w-lg tw-w-full tw-mx-auto tw-text-center">
        <a href="/"><img src="/imgs/logo-white.png" class="tw-w-16 tw-mx-auto" alt=""></a>
        <h3 class="tw-font-bold tw-font-sans tw-text-white tw-uppercase tw-text-lg md:tw-text-xl tw-tracking-widest tw-mb-0">Selecione um artista</h3>
        <p class="tw-text-white tw-font-sans tw-opacity-60 tw-mt-2 tw-mb-10 tw-text-sm md:tw-text-base">Clique em um artista abaixo para configurar seu website</p>
        <a href="https://app.musicpro.live" target="_blank" class="tw-w-full tw-uppercase tw-text-xs tw-text-white tw-text-center tw-font-sans tw-bg-purple-600 tw-py-4 tw-flex tw-items-center tw-justify-center tw-rounded tw-mt-3 waves-effet waves-light"><i class="fas fa-plus tw-mr-2"></i> Novo Artista</a>
        <v-text-field v-model="q" @click:clear="reset" color="#6E3E8C" dense outlined clearable clear-icon="mdi-close" hide-details label="Pesquisar" type="text" append-icon="mdi-magnify" @click:append="search" @keyup.enter="search" class="tw-mt-6" />
        <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-mt-3" v-if="loading">
            <v-progress-circular indeterminate color="#6E3E8C"></v-progress-circular>
        </div>
        <ul class="tw-w-full tw-text-left tw-pl-0 tw-mt-3 tw-overflow-y-auto" style="max-height:350px" v-if="!loading">
            <li class="tw-w-full tw-border-t tw-border-gray-800 hover:tw-bg-purple-800 tw-transition-all tw-duration-300" v-for="(artist, index) in artists" :key="index">
                <form action="/user/select-artist" method="POST">
                    <input type="hidden" :value="artist.artista_id" name="artista_id">
                    <input type="hidden" :value="csrf" name="_token">
                    <button type="submit" class="tw-py-2 tw-w-full tw-flex tw-items-center waves-effect waves-light tw-px-3">
                        <img :src="artist.post_image !== '' ? artist.post_image : '/imgs/default-avatar.svg'" onError="this.onerror=null;this.src='/imgs/default-avatar.svg';" class="tw-w-8 tw-h-8 md:tw-w-12 md:tw-h-12 tw-object-cover tw-rounded-full tw-mr-5">
                        <span class="tw-font-sans tw-text-white tw-text-sm md:tw-text-base tw-opacity-60">{{artist.artista_nome}}</span>
                    </button>
                </form>
            </li>
        </ul>
    </div>
</section>
</template>

<script>
import Layout from '@/Shared/NoMenu';

export default {
    layout: (h, page) => h(Layout, [page]),
    layout: Layout,
    metaInfo() {
        return {
            title: 'Selecione o artista',
        }
    },
    props: ['artists'],
    data(){
        return{
            q:'',
            loading:false,
        }
    },
    computed: {
        csrf(){
            return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        }
    },
    methods: {
        search(){
            this.loading = true;
            const vm = this;
            axios.get('/api/search-artist', {
                params: {
                    'email': vm.currentUser.email,
                    'q': vm.q
                },
            }).then(res => {
                this.loading = false
                this.artists = res.data;
            })
        },
        reset(){
            this.loading = true;
            const vm = this;
            axios.get('/api/search-artist', {
                params: {
                    'email': vm.currentUser.email,
                    'q': ''
                },
            }).then(res => {
                this.loading = false
                this.artists = res.data;
            })
        }
    },
    mounted(){
    }
}
</script>

<style>
input[type=text]:not(.browser-default){
    margin: 0!important;
    border-bottom: 0!important;
    box-shadow: none!important;
}
</style>